import React, { useState } from 'react'
import { Container, Input } from '../../../components'

const apiUrl = 'https://bnpt-api.hubton.com/api/subscribe'

// Example POST method implementation:
function postData(url = '', data = {}) {
  return new Promise(async (resolve, reject) => {
    // Default options are marked with *
    const response = await fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    });

    const json = await response.json()

    if (response.status === 200) {
      resolve(json)
    } else {
      reject(json)
    }
  })
}

const SectionNewsletter = () => {
  const [form, setForm] = useState({})
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)

    postData(apiUrl, form)
      .then(data => {
        setLoading(false)
        setSuccessMessage(data.message)
        setForm({})
        setErrors({})
      })
      .catch(err => {
        setLoading(false)
        setErrors(err)
      })
  }

  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  return (
    <Container
      color="#BB3B36"
      className={`py-16 lg:py-32 bg-center bg-cover bg-no-repeat`}
      style={{backgroundImage: `url('/images/bnpt-page-header-background.jpg')`}}
    >
      <div className="flex flex-col items-center justify-center text-center mb-8 lg:mb-16">
        <h1 className="text-2xl lg:text-4xl uppercase text-white">
          Newsletter Sign Up
        </h1>
        <div className="w-full lg:w-8/12 mx-auto">
          <p className="mt-4 lg:mt-5 text-white lg:text-lg">
            Signup with your email address to receive news and updates.
          </p>
        </div>
      </div>

      { successMessage && (
        <div className="mb-3 bg-green-100 border-green-300 text-green-600 p-4 text-sm rounded">
          { successMessage }
        </div>
      ) }

      <form className="flex flex-wrap -mx-2 lg:-mx-4 items-start" onSubmit={handleSubmit}>
        <div className="w-full lg:w-1/4 px-2 lg:px-4 mb-4 lg:mb-0">
          <Input
            className="w-full"
            placeholder="First name"
            name="first_name"
            onChange={updateForm}
          />
          {errors && 'first_name' in errors && (
            <div className="text-red-500 text-sm mt-1 bg-red-100 p-2 rounded border border-red-300">{errors.first_name[0]}</div>
          )}
        </div>

        <div className="w-full lg:w-1/4 px-2 lg:px-4 mb-4 lg:mb-0">
          <Input
            className="w-full"
            placeholder="Last name"
            name="last_name"
            onChange={updateForm}
          />
        </div>

        <div className="w-full lg:w-1/4 px-2 lg:px-4 mb-4 lg:mb-0">
          <Input
            className="w-full"
            placeholder="Email"
            type="email"
            name="email"
            onChange={updateForm}
          />
          {errors && 'email' in errors && (
            <div className="text-red-500 text-sm mt-1 bg-red-100 p-2 rounded border border-red-300">{errors.email[0]}</div>
          )}
        </div>

        <div className="w-full lg:w-1/4 px-2 lg:px-4">
          <button
            type="submit"
            disabled={loading}
            className={`w-full text-white rounded uppercase font-accent flex justify-center items-center h-full py-4 px-2 border ${loading ? 'opacity-25' : ''}`}
            style={{backgroundColor: '#181818', borderColor: '#181818'}}
          >
            Sign Up
          </button>
        </div>
      </form>
    </Container>
  )
}

export { SectionNewsletter }
